<script>
import RadioGroup from '@/components/pc/radio/ipradio/atoms/RadioGroup.vue'
import SelectBox from '@/components/pc/radio/ipradio/atoms/SelectBox.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { BC, BC_TRANS_JP } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'

export default {
  components: {
    RadioGroup,
    SelectBox,
    SettingGroup,
    SettingItem
  },

  data() {
    // ========== 静的変数 ==========
    const languageLabelByValue = Object.keys(BC.OPTIONAL_FEATURES.DATA_HOLD.LANGUAGE)
      .filter((key) => key !== 'SELECT')
      .reduce((acc, key) => {
        acc[BC.OPTIONAL_FEATURES.DATA_HOLD.LANGUAGE[key]] = BC_TRANS_JP.OPTIONAL_FEATURES.DATA_HOLD.LANGUAGE[key]
        return acc
      }, {})

    const radioBtnOptions = {
      messageDisplay: Object.keys(BC.OPTIONAL_FEATURES.DATA_HOLD.MESSAGE_DISPLAY).map((key) => {
        return {
          label: BC_TRANS_JP.OPTIONAL_FEATURES.DATA_HOLD.MESSAGE_DISPLAY[key],
          value: BC.OPTIONAL_FEATURES.DATA_HOLD.MESSAGE_DISPLAY[key],
        }
      }),
    }

    const selectboxOptions = {
      language: BC.OPTIONAL_FEATURES.DATA_HOLD.LANGUAGE.SELECT.map((value) => {
        return {
          label: languageLabelByValue[value] || value,
          value: value,
        }
      }),
    }

    return {
      radioSettings: null,
      radioBtnOptions,
      selectboxOptions,
      // ========== リアクティブ変数 ==========
      form: {
        radioBtn: {
          messageDisplay: radioBtnOptions.messageDisplay[0].value,
        },
        selectbox: {
          language: selectboxOptions.language[0].value,
        },
      },
      setting: null
    }
  },

  computed: {
    BC() {
      return BC
    }
  },

  watch: {
    form: {
      handler() {
        // フォームの内容を端末設定データに変換して反映
        this.transForm2Setting()
        // 最新の状態をストアの仮保存端末設定情報にも適用
        this.radioSettings.saveTempSetting(this.setting)
      },
      deep: true
    }
  },

  created() {
    // ストアに仮保存済みの端末設定情報を取得する
    this.radioSettings = useRadioSettingsStore()
    this.setting = this.radioSettings.getTempSetting()
    this.transSetting2Form()
  },

  methods: {
    // ========== methods ==========
    transForm2Setting() {
      const data = this.setting.OptionalFeatures.DataHold

      console.log('============================')
      console.log('before setting: ', JSON.parse(JSON.stringify(this.setting.OptionalFeatures.DataHold)))

      data.MessageDisplay = this.form.radioBtn.messageDisplay
      data.Language = this.form.selectbox.language || ''

      console.log('after setting: ', JSON.parse(JSON.stringify(this.setting.OptionalFeatures.DataHold)))
    },

    transSetting2Form() {
      const data = this.setting.OptionalFeatures.DataHold

      console.log('============================')
      console.log('before form: ', JSON.parse(JSON.stringify(this.form)))

      this.form.radioBtn.messageDisplay = data.MessageDisplay
      this.form.selectbox.language = data.Language || ''

      console.log('after form: ', JSON.parse(JSON.stringify(this.form)))
    },

    handleSelect(value) {
      this.form.selectbox.language = value
    }
  }
}
</script>

<template>
  <div>
    <SettingGroup>
      <SettingItem label="履歴表示"
        ><RadioGroup
          v-model="form.radioBtn.messageDisplay"
          :options="radioBtnOptions.messageDisplay"
          :disable="false"
        />
      </SettingItem>
      <SettingItem label="通話言語">
        <SelectBox
          :disabled="false"
          :options="selectboxOptions.language"
          :defaultValue="String(form.selectbox.language)"
          @update="handleSelect"
        />
      </SettingItem>
    </SettingGroup>
  </div>
</template>
